






























































import { addTypeContract } from '@/api/api';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';

@Component({
    filters: {
        formatHour(date: string) {
            return moment(date).format('L');
        },
    }
})
export default class ContractsDisplayer extends Vue {
    @Prop()
    contracts!: null | [];

    @Prop()
    type!: null | any;

    popupNewContract = false;
    contractContent!: string;

    async addContract() {
        console.log(this.contractContent)
    }


    created() {
        console.log(this.contracts)
    }
}
